import { Environments, IConfigurationService, IWebchatConfiguration } from "./configuration-service.model";

class ContentStackConfigurationService implements IConfigurationService {
    private static configQuery = `
        query ($chatbotEndpointName: String!){
            all_chatbot_endpoints(where: { name: $chatbotEndpointName }) {
                items {
                    cognigy_config_url
                }
            }
        }`;
    private static environmentAccessTokens: {[Key in Environments]: string} = {
        dev: 'cs63653d89d7e19fadc3d39f7e',
        fat: 'cs101fb2de6b11a8ff626ff846',
        pat: 'cse4256741d62e7966f086d350',
        prod: 'csed32ddc7308affbec19c44ec'
    } as const;

    async GetEndpointConfig(environment: Environments = "prod", variables: { chatbotEndpointName: string }): Promise<IWebchatConfiguration> {
        console.debug(`Downloading chatbot endpoints from ContentStack ${environment} environment`, variables);

        const accessToken = ContentStackConfigurationService.environmentAccessTokens[environment];
        if (!accessToken) {
          throw new Error(`Unknown environment ${environment} specified.`);
        }

        const response = await fetch(`https://eu-graphql.contentstack.com/stacks/blt2905d53358d59df0?environment=${environment}`, {
            method: 'POST',
            headers: {
                'access_token': ContentStackConfigurationService.environmentAccessTokens[environment],
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query: ContentStackConfigurationService.configQuery, variables })
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const responseBody = await response.json();
        const config = { endpointUrl: responseBody.data?.all_chatbot_endpoints?.items?.[0]?.cognigy_config_url };

        if (!config.endpointUrl) {
          throw new Error(`Endpoint configuration ${variables.chatbotEndpointName} was not found.`);
        }

        console.debug('Using endpoint configuration', config);
        return config;
    }
}

export const ContentStackConfigService = new ContentStackConfigurationService();
